import Text from 'components/Text/Text';
import { useCompareFormData } from 'hooks/useCompareFormData';
import React, { useContext } from 'react';
import { IBankSettingsContext, BankSettingsContext } from '../../bankSettingsState/bankSettingsContext';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const { changeTypeOfModalWindow, initialFormData, bankSettings } =
		useContext<IBankSettingsContext>(BankSettingsContext);

	const currentFormData = {
		bankSettings,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit" disabled={isEqualFormData}>
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
